import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import type { ReadPathScoreComponentsDto } from '@common/synapse/introspection-types';

const COMPONENT_LABELS: Array<{ key: keyof ReadPathScoreComponentsDto; color: string }> = [
  { key: 'relevance', color: '#1976d2' },
  { key: 'confidence', color: '#2e7d32' },
  { key: 'scope', color: '#6a1b9a' },
  { key: 'temporal', color: '#00838f' },
  { key: 'risk', color: '#c62828' },
];

export interface ReadPathScoreBarsProps {
  components: ReadPathScoreComponentsDto;
  compact?: boolean;
}

const ReadPathScoreBars = ({ components, compact = false }: ReadPathScoreBarsProps) => (
  <Stack spacing={compact ? 0.35 : 0.5} sx={{ minWidth: compact ? 120 : 160 }}>
    {COMPONENT_LABELS.map(({ key, color }) => (
      <Stack key={key} direction="row" alignItems="center" spacing={1}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ width: compact ? 52 : 64, textTransform: 'capitalize', flexShrink: 0 }}
        >
          {key}
        </Typography>
        <Box
          sx={{
            flex: 1,
            height: compact ? 6 : 8,
            bgcolor: 'grey.200',
            borderRadius: 1,
            overflow: 'hidden',
          }}
          aria-hidden
        >
          <Box
            sx={{
              width: `${Math.round(components[key] * 100)}%`,
              height: '100%',
              bgcolor: color,
            }}
          />
        </Box>
        <Typography variant="caption" sx={{ width: 28, textAlign: 'right', flexShrink: 0 }}>
          {components[key].toFixed(2)}
        </Typography>
      </Stack>
    ))}
  </Stack>
);

export default ReadPathScoreBars;
